import { useSelectList } from "../__chunks/X3U3KZAU.js";
import "../__chunks/F4XABKPL.js";
import "../__chunks/EEVSGAZW.js";
import "../__chunks/AAVDGJD5.js";
import "../__chunks/OXPV2NBK.js";
import "../__chunks/WJ37OVG2.js";
import { usePopover } from "../__chunks/K5MSER23.js";
import "../__chunks/SZIMOWLA.js";
import "../__chunks/5IZLNERH.js";
import "../__chunks/NHPU54IO.js";
import "../__chunks/GDORSOK6.js";
import "../__chunks/3LAWLNOX.js";
import "../__chunks/CJI67A3R.js";
import "../__chunks/PLOINBVB.js";
import "../__chunks/E5XSMSHD.js";
import "../__chunks/LEBYH5FW.js";
import "../__chunks/IXXFVVA2.js";
import "../__chunks/7JNF6I52.js";
import "../__chunks/KOVUJERF.js";
import "../__chunks/62DFK33R.js";
import "../__chunks/FW6QFGFT.js";
import "../__chunks/IYNN2ZO5.js";
import "../__chunks/5M4ITSXL.js";
import "../__chunks/6OMX4H3W.js";
import "../__chunks/LL3AE4N4.js";
import "../__chunks/EJ3GIT5B.js";
import "../__chunks/LDDPB3PY.js";
import "../__chunks/COQHFAEN.js";
import "../__chunks/LNHZLQEK.js";
import "../__chunks/M5I7AM4N.js";
import "../__chunks/WHEEIXMF.js";
import "../__chunks/6GS36SYX.js";
import "../__chunks/MYID4V27.js";
import "../__chunks/BMLNRUFQ.js";
import "../__chunks/FL2AU7YJ.js";
import { createComponent, createElement, createHook } from "../__chunks/NQJBHION.js";
import "../__chunks/SWJ5EOOS.js";
import "../__chunks/P63NRZ4A.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import { __objRest, __spreadValues } from "../__chunks/PNRLI7OV.js";

// src/select/select-popover.ts
var useSelectPopover = createHook(_a => {
  var _b = _a,
    {
      store,
      alwaysVisible
    } = _b,
    props = __objRest(_b, ["store", "alwaysVisible"]);
  props = useSelectList(__spreadValues({
    store,
    alwaysVisible
  }, props));
  props = usePopover(__spreadValues({
    store,
    alwaysVisible
  }, props));
  return props;
});
var SelectPopover = createComponent(props => {
  const htmlProps = useSelectPopover(props);
  return createElement("div", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  SelectPopover.displayName = "SelectPopover";
}
export { SelectPopover, useSelectPopover };